import React from 'react'
import UseLang from '../../../../hooks/UseLang'

function Referencia() {
    return (
        <div  id="p7">
            <UseLang es>

                <h4 id="otras">Otras Referencias</h4>
                <p>Adem&aacute;s de las citadas durante el informe, se han usado las siguientes referencias como fuentes de
                    informaci&oacute;n:
                    <ul>
                        <li><a href="https://www.gartner.com/reviews/market/ddos-mitigation-solutions"
                            target="_blank" rel="noreferrer">https://www.gartner.com/reviews/market/ddos-mitigation-solutions</a></li>
                        <li><a href="https://www.cloudflare.com/static/d442dfee7ea56f899d8df461bb7a077f/BDES-2587-Design-Wrap-Refreshed-DDoS-White-Paper-Letter.pdf"
                            target="_blank" rel="noreferrer">https://www.cloudflare.com/static/d442dfee7ea56f899d8df461bb7a077f/BDES-2587-Design-Wrap-Refreshed-DDoS-White-Paper-Letter.pdf</a>
                        </li>
                        <li><a href="https://cert.europa.eu/static/WhitePapers/CERT-EU_Security_Whitepaper_DDoS_17-003.pdf "
                            target="_blank" rel="noreferrer">https://cert.europa.eu/static/WhitePapers/CERT-EU_Security_Whitepaper_DDoS_17-003.pdf</a>
                        </li>
                    </ul>
                </p>
            </UseLang>
            <UseLang en>
                <h4 id="otras">Additional references</h4>
                <p>In addition to the references cited throughout the report, the following have also served as sources of information:
                    <ul>
                        <li><a href="https://www.gartner.com/reviews/market/ddos-mitigation-solutions" target="_blank" rel="noreferrer">https://www.gartner.com/reviews/market/ddos-mitigation-solutions</a></li>
                        <li><a href="https://www.cloudflare.com/static/d442dfee7ea56f899d8df461bb7a077f/BDES-2587-Design-Wrap-Refreshed-DDoS-White-Paper-Letter.pdf" target="_blank" rel="noreferrer">https://www.cloudflare.com/static/d442dfee7ea56f899d8df461bb7a077f/BDES-2587-Design-Wrap-Refreshed-DDoS-White-Paper-Letter.pdf</a></li>
                        <li><a href="https://cert.europa.eu/static/WhitePapers/CERT-EU_Security_Whitepaper_DDoS_17-003.pdf " target="_blank" rel="noreferrer">https://cert.europa.eu/static/WhitePapers/CERT-EU_Security_Whitepaper_DDoS_17-003.pdf</a></li>
                    </ul>
                </p>
            </UseLang>
            <UseLang pt>

                <h4 id="otras">Outras referências</h4>
                <p>Além das citadas durante o relatório, as seguintes referências foram usadas como fonte de informação::
                    <ul>
                        <li><a href="https://www.gartner.com/reviews/market/ddos-mitigation-solutions" target="_blank" rel="noreferrer">https://www.gartner.com/reviews/market/ddos-mitigation-solutions</a></li>
                        <li><a href="https://www.cloudflare.com/static/d442dfee7ea56f899d8df461bb7a077f/BDES-2587-Design-Wrap-Refreshed-DDoS-White-Paper-Letter.pdf" target="_blank" rel="noreferrer">https://www.cloudflare.com/static/d442dfee7ea56f899d8df461bb7a077f/BDES-2587-Design-Wrap-Refreshed-DDoS-White-Paper-Letter.pdf</a></li>
                        <li><a href="https://cert.europa.eu/static/WhitePapers/CERT-EU_Security_Whitepaper_DDoS_17-003.pdf " target="_blank" rel="noreferrer">https://cert.europa.eu/static/WhitePapers/CERT-EU_Security_Whitepaper_DDoS_17-003.pdf</a></li>
                    </ul>
                </p>

            </UseLang>
        </div>
    )
}

export default Referencia
